import { MAGENTO_PAYMENT_METHOD_COMMON, MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY } from "@checkout-v2/shared";

import type { UseCheckoutFastFlowArgs } from "../../useCheckoutFastFlow";

import type { FastFlowPaymentStepCandidateReady, PaymentStepFastFlowCandidate } from ".";

const isMagentoPaymentMethodTypeIsValid = (
  magentoPaymentMethodType: string
): magentoPaymentMethodType is typeof MAGENTO_PAYMENT_METHOD_COMMON | typeof MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY => {
  return (
    magentoPaymentMethodType === MAGENTO_PAYMENT_METHOD_COMMON ||
    magentoPaymentMethodType === MAGENTO_PAYMENT_METHOD_PAY_ON_DELIVERY
  );
};

export const isFastFlowPaymentStepCandidateReady = (
  candidate: FastFlowPaymentStepCandidateReady | null
): candidate is FastFlowPaymentStepCandidateReady => {
  return candidate !== null;
};

export const buildPaymentStepFastFlowCandidate = ({
  lastOrderData,
  paymentOptions,
}: Pick<UseCheckoutFastFlowArgs, "lastOrderData" | "paymentOptions">): PaymentStepFastFlowCandidate | null => {
  if (!lastOrderData?.payment_methods?.[0]?.type) {
    return null;
  }

  const lastOrderAvailablePaymentMethod = paymentOptions.find(
    (option) => option.code === lastOrderData.payment_methods?.[0]?.method_code && !option.disabled
  )
    ? lastOrderData.payment_methods?.[0]
    : null;

  if (!lastOrderAvailablePaymentMethod) {
    return null;
  }

  const paymentSectionMethodCode = lastOrderAvailablePaymentMethod.method_code;
  const magentoPaymentMethodType = lastOrderAvailablePaymentMethod.type;

  if (!isMagentoPaymentMethodTypeIsValid(magentoPaymentMethodType)) {
    return null;
  }

  if (!paymentSectionMethodCode) {
    return null;
  }

  return { paymentMethodCode: paymentSectionMethodCode, magentoPaymentMethodType };
};
